export const scrollPage = (elementId: string) => {
    
    const target = document.getElementById(`${elementId}`);
    if (!target || target === undefined) return;
    target.scrollIntoView({behavior: 'smooth'});
    // target.scrollIntoView({behavior: 'auto'});
};
